/* <cr-hero> — mockup script.js:242-287 (slideshow) and 360-366 (next Friday drop date). */
if (!customElements.get('cr-hero')) {
  customElements.define('cr-hero', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-cr-track]');
      this.slides = Array.from(this.querySelectorAll('[data-cr-slide]'));
      this.dots = Array.from(this.querySelectorAll('.cr-ss-dot'));
      this.toggle = this.querySelector('[data-ss="toggle"]');
      this.delay = parseInt(this.dataset.delay, 10) || 6000;
      this.i = 0;
      this.paused = this.dataset.autoplay !== 'true';
      this.hold = false;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.updateDropDate();
      if (this.slides.length < 2) return;

      const prev = this.querySelector('[data-ss="prev"]');
      const next = this.querySelector('[data-ss="next"]');
      if (prev) prev.addEventListener('click', () => this.go(this.i - 1));
      if (next) next.addEventListener('click', () => this.go(this.i + 1));
      if (this.toggle) this.toggle.addEventListener('click', () => this.setPaused(!this.paused));
      this.dots.forEach((d, k) => d.addEventListener('click', () => this.go(k)));

      // Pause while the visitor is looking / interacting (js:273-276)
      this.addEventListener('mouseenter', () => { this.hold = true; this.restart(); });
      this.addEventListener('mouseleave', () => { this.hold = false; this.restart(); });
      this.addEventListener('focusin', () => { this.hold = true; this.restart(); });
      this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) { this.hold = false; this.restart(); } });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') this.go(this.i + 1);
        if (e.key === 'ArrowLeft') this.go(this.i - 1);
      });

      // Swipe (js:278-283): horizontal move > 50px
      let x0 = null, y0 = 0;
      this.track.addEventListener('pointerdown', (e) => { x0 = e.clientX; y0 = e.clientY; });
      this.track.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0, dy = e.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.go(dx < 0 ? this.i + 1 : this.i - 1);
      });

      if (window.Shopify && window.Shopify.designMode) {
        this.onBlockSelect = (e) => {
          const k = this.slides.indexOf(e.target);
          if (k > -1) { this.editorHold = true; this.go(k); }
        };
        this.onBlockDeselect = (e) => { if (this.slides.includes(e.target)) { this.editorHold = false; this.restart(); } };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      this.setPaused(this.paused || this.reduce, true);
      this.go(0);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.onBlockSelect) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }
    }

    // js:250-256
    go(n) {
      const count = this.slides.length;
      this.i = (n + count) % count;
      this.track.style.transform = 'translateX(' + (-100 * this.i) + '%)';
      this.slides.forEach((s, k) => {
        s.classList.toggle('is-active', k === this.i);
        if (k === this.i) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
      this.dots.forEach((d, k) => d.setAttribute('aria-current', k === this.i ? 'true' : 'false'));
      this.restart();
    }

    playing() { return !this.paused && !this.hold && !this.reduce && !this.editorHold; }

    // js:258-262 — restarting re-triggers the dot fill animation
    restart() {
      clearTimeout(this.timer);
      this.classList.remove('is-playing');
      void this.offsetWidth;
      if (this.playing()) {
        this.classList.add('is-playing');
        this.timer = setTimeout(() => this.go(this.i + 1), this.delay);
      }
    }

    // js:263-268
    setPaused(p, silent) {
      this.paused = p;
      this.classList.toggle('is-paused', p);
      if (this.toggle) this.toggle.setAttribute('aria-label', p ? this.dataset.labelPlay : this.dataset.labelPause);
      if (!silent) this.restart();
    }

    // js:361-366 — next Friday in the visitor's local time ("Today, …" on a Friday), or the override date.
    updateDropDate() {
      const dayEl = this.querySelectorAll('[data-cr-drop-day]');
      const dateEl = this.querySelectorAll('[data-cr-drop-date]');
      if (!dayEl.length) return;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      let d;
      const o = (this.dataset.override || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (o) d = new Date(+o[1], +o[2] - 1, +o[3]);
      else { d = new Date(today); d.setDate(d.getDate() + ((5 - d.getDay() + 7) % 7)); }
      const lang = document.documentElement.lang || undefined;
      const weekday = d.toLocaleDateString(lang, { weekday: 'long' });
      const month = d.toLocaleDateString(lang, { month: 'long' });
      const prefix = d.getTime() === today.getTime() ? (this.dataset.today || weekday) : weekday;
      dayEl.forEach((el) => { el.textContent = d.getDate(); });
      const format = this.dataset.dateFormat || '';
      const text = format.replace('[weekday]', prefix).replace('[day]', d.getDate()).replace('[month]', month);
      dateEl.forEach((el) => { el.textContent = text; });
    }
  });
}
